// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* BModal se monta en body: sus piezas propias y las variables no heredan de la página. */
.permisos-modal {
    --ink: #1b2740;
    --soft: #5c6b86;
    --line: #d5deea;
    --field: #8b97ab;
    --sheet: #f3f6fa;
    --senal: #ff7900;
    --peligro: #9b1c3c;
    --mono: ui-monospace, "SFMono-Regular", "Cascadia Mono", Menlo, Consolas, monospace;
    color: var(--ink);
}
.permisos-modal .modal-content {
    border: 1px solid var(--line);
    border-top: 3px solid var(--senal);
    border-radius: 6px;
    box-shadow: 0 18px 48px rgba(27, 39, 64, 0.22);
}
.permisos-modal .modal-header {
    align-items: flex-start;
    padding: 1.1rem 1.35rem 0.9rem;
    border-bottom: 1px solid var(--line);
}
.permisos-modal .modal-title {
    min-width: 0;
    font-size: 1.1rem;
    font-weight: 600;
    color: var(--ink);
}
.permisos-modal .modal-body {
    padding: 1.2rem 1.35rem 1.35rem;
}
.permisos-modal .modal-footer {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 1.35rem;
    border-top: 1px solid var(--line);
    background: var(--sheet);
}
.permisos-modal .modal-footer > * {
    margin: 0;
}
.permisos-modal .modal-footer .btn {
    border-radius: 4px;
    font-weight: 600;
}
.permisos-modal .modal-footer .permisos-commit {
    background: var(--ink);
    border-color: var(--ink);
    color: #fff;
}
.permisos-modal .modal-footer .permisos-commit:hover {
    background: #121a2c;
    border-color: #121a2c;
}
.permisos-modal-peligro .modal-content {
    border-top-color: var(--peligro);
}
.permisos-modal .modal-footer .btn-danger {
    background: var(--peligro);
    border-color: var(--peligro);
    color: #fff;
}
.permisos-modal .modal-footer .btn-danger:hover {
    background: #7d1530;
    border-color: #7d1530;
}
.permisos-modal .modal-footer .btn:focus-visible {
    outline: 2px solid var(--ink);
    outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/permisosUser.vue"],"names":[],"mappings":";AAg3CA,yFAAyF;AACzF;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mFAAmF;IACnF,iBAAiB;AACrB;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,kBAAkB;IAClB,8CAA8C;AAClD;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,oCAAoC;AACxC;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;AAEA;IACI,+BAA+B;AACnC;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,SAAS;IACT,wBAAwB;IACxB,iCAAiC;IACjC,wBAAwB;AAC5B;AAEA;IACI,SAAS;AACb;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AAEA;IACI,sBAAsB;IACtB,wBAAwB;IACxB,WAAW;AACf;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AAEA;IACI,gCAAgC;AACpC;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,WAAW;AACf;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;AAEA;IACI,6BAA6B;IAC7B,mBAAmB;AACvB","sourcesContent":["\n/* BModal se monta en body: sus piezas propias y las variables no heredan de la página. */\n.permisos-modal {\n    --ink: #1b2740;\n    --soft: #5c6b86;\n    --line: #d5deea;\n    --field: #8b97ab;\n    --sheet: #f3f6fa;\n    --senal: #ff7900;\n    --peligro: #9b1c3c;\n    --mono: ui-monospace, \"SFMono-Regular\", \"Cascadia Mono\", Menlo, Consolas, monospace;\n    color: var(--ink);\n}\n\n.permisos-modal .modal-content {\n    border: 1px solid var(--line);\n    border-top: 3px solid var(--senal);\n    border-radius: 6px;\n    box-shadow: 0 18px 48px rgba(27, 39, 64, 0.22);\n}\n\n.permisos-modal .modal-header {\n    align-items: flex-start;\n    padding: 1.1rem 1.35rem 0.9rem;\n    border-bottom: 1px solid var(--line);\n}\n\n.permisos-modal .modal-title {\n    min-width: 0;\n    font-size: 1.1rem;\n    font-weight: 600;\n    color: var(--ink);\n}\n\n.permisos-modal .modal-body {\n    padding: 1.2rem 1.35rem 1.35rem;\n}\n\n.permisos-modal .modal-footer {\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: center;\n    gap: 1rem;\n    padding: 0.75rem 1.35rem;\n    border-top: 1px solid var(--line);\n    background: var(--sheet);\n}\n\n.permisos-modal .modal-footer > * {\n    margin: 0;\n}\n\n.permisos-modal .modal-footer .btn {\n    border-radius: 4px;\n    font-weight: 600;\n}\n\n.permisos-modal .modal-footer .permisos-commit {\n    background: var(--ink);\n    border-color: var(--ink);\n    color: #fff;\n}\n\n.permisos-modal .modal-footer .permisos-commit:hover {\n    background: #121a2c;\n    border-color: #121a2c;\n}\n\n.permisos-modal-peligro .modal-content {\n    border-top-color: var(--peligro);\n}\n\n.permisos-modal .modal-footer .btn-danger {\n    background: var(--peligro);\n    border-color: var(--peligro);\n    color: #fff;\n}\n\n.permisos-modal .modal-footer .btn-danger:hover {\n    background: #7d1530;\n    border-color: #7d1530;\n}\n\n.permisos-modal .modal-footer .btn:focus-visible {\n    outline: 2px solid var(--ink);\n    outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
